import React from "react";

interface TableRow {
  label: string;
  return: number;
  risk: number;
}

export default function RiskVsReturnTable({ data }: { data: TableRow[] }) {
  const renderCell = (value: number) => {
    const isNegative = value < 0;

    return (
      <td className={`py-5 font-medium text-center px-2 ${isNegative ? "text-red-600" : "text-green-600"}`}>
        <div className="flex items-center justify-center gap-1">
          <i
            className={`inline-block mr-1 align-middle w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent ${isNegative ? "border-t-[5px] border-t-red-700" : "border-b-[5px] border-b-[#2C841C]"}`}
          />
          {value > 0 ? `+${value.toFixed(2)}%` : `${value.toFixed(2)}%`}
        </div>
      </td>
    );
  };

  const tableHead = [
    { id: 1, value: "" },
    { id: 2, value: "Return" },
    { id: 3, value: "Risk" },
  ];

  return (
    <div className="flex-1 flex flex-col items-end sm:max-w-[45%] p-0 sm:p-6">
      <table className="w-full border-collapse">
        <thead>
          <tr className="text-left border-b text-base text-primaryBlack px-2">
            {tableHead.map((idx) => (
              <th key={idx.id} className="pb-5 font-medium text-center">
                {idx.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx} className="border-b text-sm">
              <td className="py-5 px-2 text-[#444]">{row.label}</td>
              {renderCell(row.return)}
              {renderCell(row.risk)}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-5 sm:mt-auto text-left text-xs italic text-[#6E6E73]">
        *Size of Bubbles represents the Fund Size
      </p>
    </div>
  );
}
